import AdminDiscussion from 'shared/components/admin_discussion';
import Discussion from 'shared/components/discussion';
import Page from 'shared/components/page';
import { VidioHelpers } from 'shared/vidio_helpers';

export default class DiscussionLivestreaming {
  constructor() {
    this.chatDOM = document.querySelector(".livestreaming-discussion");
  }

  getLivestreamingId() {
    return Page.id();
  }

  init() {
    return this.requestTemplate().then(data => {
      if (data.show_chat) {
        this.initJSComponent(data);
      }
      return data;
    });
  }

  initJSComponent(data) {
    if (VidioHelpers.isMobile()) {
      this.initUserDiscussion();
    } else {
      this.chatDOM.innerHTML = data.html_content;
      this.switchComponent(data);
    }
  }

  requestTemplate() {
    const url = `/live/${this.getLivestreamingId()}/show_discussion_template`;

    const options = {
      method: "GET",
      url: url
    };

    return $.ajax(options);
  }

  switchComponent({ template_name }) {
    switch(template_name) {
      case "AdminDiscussion":
        return this.initAdminDiscussion();
      case "UserDiscussion":
        return this.initUserDiscussion();
      default:
        return;
    }
  }

  initAdminDiscussion() {
    new Discussion();
    new AdminDiscussion().init();
  }

  initUserDiscussion() {
    new Discussion().init();
  }
}
